import { makeAutoObservable } from "mobx";
import { Availability } from "../Availability";
import { RArray } from "../../collections";
import { RDate } from "../../core";
export class OnlinePurchaseOrderFulfillmentTime {
    constructor(params) {
        this.type = "Online";
        this.restaurant = params.restaurant;
        this.payload = params.payload;
        this.fulfillmentInstructions = params.fulfillmentInstructions;
        // TODO: get "now" from the scope?
        this.now = RDate.now(this.restaurant.timezone);
        makeAutoObservable(this);
    }
    get fulfillmentTime() {
        return this.fulfillmentInstructions.fulfillmentTime;
    }
    set fulfillmentTime(value) {
        this.fulfillmentInstructions.fulfillmentTime = value;
    }
    get timezone() {
        return this.restaurant.timezone;
    }
    get activeDate() {
        const date = this.fulfillmentTime !== null && this.fulfillmentTime.type === "OnTime"
            ? this.fulfillmentTime.date
            : null;
        if (date === null) {
            return null;
        }
        return this.getDate(date);
    }
    get preorderSettings() {
        return this.payload.orderLines.flatMap((orderLine) => orderLine.preorderSettings);
    }
    get isPreorder() {
        return (!this.preorderSettings.isEmpty &&
            !this.preorderSettings.some((item) => item.tag === "SameDay"));
    }
    get preorderDates() {
        const dateRange = this.preorderSettings.reduce((dateRange, preorderSetting) => {
            const preorderDateRange = preorderSetting.dateRange(this.now);
            return dateRange === null
                ? preorderDateRange
                : dateRange.intersection(preorderDateRange);
        }, null);
        if (dateRange === null) {
            return RArray.empty();
        }
        return dateRange.days;
    }
    /**
     * Returns available dates with hours for each date.
     * - removed past dates
     * - removed dates without available hours
     */
    get availableDates() {
        return this.preorderDates
            .filtered((date) => date.isToday || date.isAfter(this.now))
            .map((date) => ({
            date,
            hours: this.restaurant
                .dateFulfillmentTimes(date)
                .map((item) => item.date),
        }))
            .filtered(({ hours }) => !hours.isEmpty);
    }
    getDate(date) {
        return this.availableDates.findWhere((item) => item.date.isSame(date, "day"));
    }
    // TODO: move ASAP label translations to the client (currently received from RPC)
    get asapLabel() {
        var _a, _b, _c;
        return ((_c = (_b = (_a = this.restaurant.fulfillmentTimes) === null || _a === void 0 ? void 0 : _a.findWhere((item) => item.type === "ASAP")) === null || _b === void 0 ? void 0 : _b.label) !== null && _c !== void 0 ? _c : "");
    }
    get asapOptionAvailable() {
        const hasAsapFulfillmentTime = this.restaurant.fulfillmentTimes !== null
            ? this.restaurant.fulfillmentTimes.some((item) => item.type === "ASAP")
            : false;
        const hasTodayDate = this.preorderDates.some((date) => date.isToday);
        return hasAsapFulfillmentTime && hasTodayDate;
    }
    get inFutureOptionAvailabile() {
        return this.isPreorder && !this.availableDates.isEmpty;
    }
    get todayOptionAvailable() {
        return this.availableDates.some((item) => item.date.isToday);
    }
    get availability() {
        var _a, _b;
        const domainDate = this.fulfillmentTime !== null && this.fulfillmentTime.type === "OnTime"
            ? this.fulfillmentTime.date
            : null;
        const availableDate = this.activeDate;
        const isAnyOptionAvailable = this.asapOptionAvailable ||
            this.todayOptionAvailable ||
            this.inFutureOptionAvailabile;
        return Availability.boolean({
            FulfillmentDateOutOfRange: domainDate !== null && availableDate === null,
            FulfillmentDatesEmpty: this.availableDates.isEmpty &&
                !((_b = (_a = this.restaurant.fulfillmentTimes) === null || _a === void 0 ? void 0 : _a.some((ft) => ft.type === "ASAP")) !== null && _b !== void 0 ? _b : true),
            FulfillmentTimeOutOfRange: domainDate !== null &&
                availableDate !== null &&
                !availableDate.hours.some((time) => time.fullHour === domainDate.fullHour),
            FulfillmentTimesEmpty: availableDate !== null && availableDate.hours.isEmpty,
            FulfillmentTimeOptionsMissing: !isAnyOptionAvailable,
            PreorderDatesEmpty: this.isPreorder && this.preorderDates.isEmpty,
        });
    }
}
